import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <svg class="size-4" aria-hidden="true" viewBox="0 0 48 48" {{mergeClasses}} ...attributes>
    <circle class="stroke-gray-300" cx="24" cy="24" r="20" fill="none" stroke-width="5" />
    <g class="origin-center animate-spin">
      <circle
        class="stroke-black [stroke-linecap:round] [stroke-dasharray:40_200] [stroke-dashoffset:10]"
        cx="24"
        cy="24"
        r="20"
        fill="none"
        stroke-width="5"
      />
    </g>
  </svg>
</template>
